import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { GANG_ACTIVE } from "@/lib/gang";

let tiersPromise = null;

/** Gang tiers (public) + the signed-in member's live tier, cached across pages. */
export function useGang() {
    const { user } = useAuth();
    const [tiers, setTiers] = useState([]);
    const [member, setMember] = useState(null);

    useEffect(() => {
        tiersPromise = tiersPromise || api.get("/membership/tiers").then(({ data }) => data.tiers || []);
        let alive = true;
        tiersPromise.then((t) => alive && setTiers(t)).catch(() => { tiersPromise = null; });
        return () => { alive = false; };
    }, []);

    useEffect(() => {
        if (!user) { setMember(null); return; }
        api.get("/membership/me").then(({ data }) => {
            const m = data.membership;
            setMember(m && GANG_ACTIVE.includes(m.status) && data.tier
                ? { ...data.tier, status: m.status } : null);
        }).catch(() => setMember(null));
    }, [user]);

    return { tiers, member };
}
